import axios, { dispatch, mutate, receive, remove } from "./api.service";

export const getAllJobs = () => receive("/jobs");

export const getFilteredJobs = (search) =>
  receive(`/jobs?title=${search}&title=${search}`);

export const applyJob = (jobId) => axios.post(`/jobs/${jobId}/apply`);

export const getUserJobApplications = () => receive("/user/jobs/applications");

export const getUserJobs = () => receive("/user/jobs");

export const getJobApplicants = (id) => receive(`jobs/${id}/applications`);

export const getSuggestedJobs = () => receive("/user/suggest-jobs");

export const getJobById = (id) => receive(`/job/${id}`);

export const getJobBySlug = (slug) => receive(`/job/slug/${slug}`);

export const deleteJob = (id) => remove(`/jobs/${id}`);

export const updateJob = (data, id) => mutate(data, `/jobs/${id}`);

export const updateJobApplicant = (data, id) =>
  dispatch(data, `/jobs/applicant/${id}`);

export const getJobSkills = () => receive(`/job-skill`);

export const getJobTypes = () => receive(`/job-type`);

export const getJobCertifications = () => receive(`/job-certification`);

export const getJobSectors = () => receive(`/job-sector`);

export const getJobTitles = () => receive(`/job-title`);
export const getJobLevels = () => receive(`/job-level`);

export const postJob = (data) => dispatch(data, "/jobs");
